<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<ng-container *cignaResponsive="let screen">
  <ng-container *ngIf="showTableData">
    <div class="border-radius"></div>
    <div class="mt-4">
      <div class="d-inline">
        <div class="result-header d-inline">
          <strong>{{ 'drugNameSearch.results' | translate }}</strong>
        </div>
        <div
          class="pr-3 float-right"
          *ngIf="
            !showSearchInfo && consumerId !== 'chcp' && !isClassCodeClicked
          "
        >
          <a
            class="pdl-link float-right clickable"
            target="_blank"
            href="{{ downloadPdf }}/{{ otherInfo.pdfFileName }}"
          >
            {{ 'drugNameSearch.download' | translate }}</a
          >
        </div>
        <cigna-print-pdl
          [showSearchInfo]="showSearchInfo"
          [isClassCodeClicked]="isClassCodeClicked"
          [selectedDrugList]="selectedDrugList"
          [alphabet]="alphabet"
          [notesCollection]="notesCollection"
          [indicator]="indicator"
          [rsdLimitValue]="rsdLimit"
          [msdLimitValue]="msdLimit"
          [otherInfo]="otherInfo"
          [consumerId]="consumerId"
          [selectedItem]="selectedItem"
        ></cigna-print-pdl>
      </div>

      <ng-container
        *ngIf="selectedDrugList.length > 0 && consumerId === 'chcp'"
      >
        <div
          class="pt-2"
          *ngIf="showSearchInfo && !isClassCodeClicked"
          [innerHTML]="
            'drugNameSearch.result_info.hcp.searched_list'
              | translate : { searchString: alphabet }
          "
        ></div>
        <div class="pb-3 pt-1" *ngIf="isClassCodeClicked">
          Here are your results for the search term
          <b>{{ selectedDrugList[0].therapeuticClass }}</b>
        </div>
      </ng-container>
      <div
        class="pt-2 rx-cnt-error"
        *ngIf="showSearchInfo && selectedDrugList.length === 0"
        [innerHTML]="
          'drugNameSearch.error_messages.hcp.incorrect_drug_name.message'
            | translate : { searchString: alphabet }
        "
      ></div>
    </div>
    <ng-container
      *ngIf="
        consumerId !== 'chcp' &&
        !showSearchInfo &&
        alphabet !== undefined &&
        alphabet !== ''
      "
    >
      <div class="row pt-4">
        <div class="col-sm-12 pl-0">
          Here is the complete drug list for
          <b>{{ selectedItem.display }}</b>
          <div class="pt-2 font-weight-bold">
            {{ 'drugNameSearch.filter_by_drug.cigna' | translate }}
          </div>
        </div>
      </div>
    </ng-container>
    <div class="row" [ngClass]="{ 'pt-2': consumerId === 'chcp' }">
      <div
        class="col-sm-12 ml-2 mr-2 pb-1 pdl-link"
        [ngClass]="consumerId === 'chcp' ? 'pl' : 'pl-2'"
        *ngIf="!showSearchInfo && alphabet !== undefined && alphabet !== ''"
      >
        <ng-container *ngIf="screen.isLargerOrEqual('md')">
          <div class="mr-2" *ngFor="let item of atoz; let index = index">
            <span
              (click)="drugsListClick(item)"
              class="float-left clickable alphabet-class"
              [class.active]="alphabet == item"
              >{{ item }}</span
            >
            <div
              class="float-left alpha-separator"
              *ngIf="index !== atoz?.length - 1"
            ></div>
          </div>
        </ng-container>
        <ng-container *ngIf="screen.isSmallerOrEqual('sm')">
          <label>
            <select
              cignaSelect
              class="w-100 clr-black"
              (change)="drugsListClick($event.target.value)"
            >
              <ng-container *ngFor="let item of atoz; let i = index">
                <option
                  class="rx-res"
                  [value]="item"
                  [selected]="item === alphabet"
                >
                  {{ item }}
                </option>
              </ng-container>
            </select>
          </label>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="selectedDrugList.length && consumerId !== 'chcp'">
      <div class="pb-3 pt-1" *ngIf="isClassCodeClicked">
        Here are your results for the search term
        <b>{{ selectedDrugList[0].therapeuticClass }}</b> found in
        <b>{{ selectedItem.display }}</b>
      </div>
      <div class="pb-3 pt-1" *ngIf="showSearchInfo && !isClassCodeClicked">
        Here are your results for the search term
        <b>{{ alphabet }}</b> found in
        <b>{{ selectedItem.display }}</b>
      </div>
    </ng-container>

    <div class="pdl-code" *ngIf="consumerId === 'cignaaccess'">
      <cigna-icon type="info-circle"></cigna-icon>
      {{
        'drugNameSearch.pdl_message_code.cignaaccess.' + planCode + '.message'
          | translate
      }}
    </div>
    <div class="pdl-code" *ngIf="consumerId === 'hcp'">
      <cigna-icon type="info-circle"></cigna-icon>
      {{
        'drugNameSearch.pdl_message_code.cignaaccess.' + planCode + '.message'
          | translate
      }}
    </div>
    <div class="pdl-code" *ngIf="consumerId === 'myCigna'">
      <cigna-icon type="info-circle"></cigna-icon>
      {{
        'drugNameSearch.pdl_message_code.cignaaccess.' + planCode + '.message'
          | translate
      }}
    </div>
    <ng-container *ngIf="screen.isLargerOrEqual('md')">
      <table class="table drug-doublerow-table">
        <thead>
          <tr class="header text-aln">
            <th class="bold cg-border">
              {{ 'drugNameSearch.drugs_grid_header.drug_name' | translate }}
            </th>
            <th class="bold cg-border">
              {{ 'drugNameSearch.drugs_grid_header.strength' | translate }}
            </th>
            <th class="bold cg-border">
              {{ 'drugNameSearch.drugs_grid_header.dosage_form' | translate }}
            </th>
            <th class="bold cg-border">
              {{ 'drugNameSearch.drugs_grid_header.class' | translate }}
            </th>
            <th class="bold cg-border">
              {{ 'drugNameSearch.drugs_grid_header.tier' | translate }}
            </th>
            <th class="bold cg-border">
              {{ 'drugNameSearch.drugs_grid_header.notes' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th
              colspan="6"
              class="cell-group cell-align pl-0 pb-0"
              *ngIf="alphabet !== '' && !showSearchInfo"
            >
              <div>
                <div class="cell-group-content">{{ alphabet }}</div>
              </div>
            </th>
          </tr>
          <ng-container *ngFor="let drug of selectedDrugList">
            <tr class="trow">
              <td class="td-data pl-2">
                {{ drug.drugName }}
                <div
                  class="info"
                  *ngIf="
                    (drug?.strength?.length ||
                      drug?.dosageFormDesc?.length ||
                      drug?.dosageForm?.length) >= 2
                  "
                >
                  {{ 'drugNameSearch.multiple_variation_info' | translate }}
                </div>
              </td>
              <td class="td-data p-0">
                <ng-container>
                  <table class="row-width">
                    <tr *ngFor="let strength of drug.strength">
                      <td class="ft-child" *ngIf="strength">
                        {{ strength }}
                      </td>
                      <td class="ft-child" *ngIf="!strength">&#8203;</td>
                    </tr>
                  </table>
                </ng-container>
              </td>
              <td class="td-data p-0">
                <ng-container *ngIf="consumerId === 'chcp'; else nonChcp">
                  <table class="row-width">
                    <tr *ngFor="let dosageFormDesc of drug.dosageFormDesc">
                      <td class="ft-child" *ngIf="dosageFormDesc">
                        {{ dosageFormDesc }}
                      </td>
                      <td class="ft-child" *ngIf="!dosageFormDesc">&#8203;</td>
                    </tr>
                  </table>
                </ng-container>
                <ng-template #nonChcp>
                  <table class="row-width">
                    <tr *ngFor="let dosageForm of drug.dosageForm">
                      <td class="ft-child" *ngIf="dosageForm">
                        {{ dosageForm }}
                      </td>
                      <td class="ft-child" *ngIf="!dosageForm">&#8203;</td>
                    </tr>
                  </table>
                </ng-template>
              </td>
              <td
                class="td-data pl-2 word-brk clickable pdl-link"
                (click)="loadTherapeuticCode(drug.therapeuticClassCode, false)"
              >
                {{ drug.therapeuticClass }}
              </td>
              <td class="td-data p-0">
                <table class="row-width">
                  <ng-container *ngFor="let tier of drug.tier">
                    <tr>
                      <td class="ft-child" *ngIf="tier">
                        {{ tier }}
                      </td>
                      <td class="ft-child" *ngIf="!tier">&#8203;</td>
                    </tr>
                  </ng-container>
                </table>
              </td>
              <td class="td-data p-0">
                <table class="row-width">
                  <ng-container *ngFor="let data of drug.notes">
                    <tr>
                      <td class="ft-child" *ngIf="data.length > 0">
                        <span *ngFor="let note of data; index as i">
                          <cigna-popover
                            popoverId="popover-notes"
                            role="button"
                            [underlineStyle]="'tooltip'"
                            [content]="popoverContent_notes"
                            [placement]="'top'"
                            [openOnHover]="true"
                          >
                            {{ note }}</cigna-popover
                          >
                          <label *ngIf="data.length > 1 && i != data.length - 1"
                            >,</label
                          >
                          <ng-template #popoverContent_notes>
                            <span
                              *ngIf="
                                !['SD', 'SDS'].includes(note) &&
                                  !(isNYMessage && note === 'DS');
                                else nyMessage
                              "
                            >
                              {{
                                'drugNameSearch.notes.' + note + '.long_form'
                                  | translate
                              }}
                              ({{
                                'drugNameSearch.notes.' + note + '.short_form'
                                  | translate
                              }})
                              <br />
                              <br />
                              <span
                                [innerHTML]="
                                  'drugNameSearch.notes.' +
                                    note +
                                    '.description' | translate
                                "
                              >
                              </span>
                            </span>
                            <span *ngIf="note === 'SDS'">
                              <span
                                *ngIf="msdLimit === rsdLimit; else dayLimit"
                              >
                                {{
                                  'drugNameSearch.notes.' + note + '.long_form'
                                    | translate
                                }}
                                ({{
                                  'drugNameSearch.notes.' + note + '.short_form'
                                    | translate
                                }})
                                <br />
                                <br />
                                {{
                                  'drugNameSearch.notes.SDS.description_XX'
                                    | translate : { msdLimit: msdLimit }
                                }}
                              </span>
                            </span>
                            <span *ngIf="note === 'SD'">
                              <span
                                *ngIf="
                                  otherInfo.mailSpecialtyDaySupply ===
                                    otherInfo.retailSpecialtyDaySupply;
                                  else daySupply
                                "
                              >
                                {{
                                  'drugNameSearch.notes.' + note + '.long_form'
                                    | translate
                                }}
                                ({{
                                  'drugNameSearch.notes.' + note + '.short_form'
                                    | translate
                                }})
                                <br />
                                <br />
                                {{
                                  'drugNameSearch.notes.SD.description_XX'
                                    | translate
                                      : {
                                          msdSupply:
                                            otherInfo.mailSpecialtyDaySupply
                                        }
                                }}
                              </span>
                            </span>
                          </ng-template>
                          <ng-template #dayLimit>
                            <span>
                              {{
                                'drugNameSearch.notes.' + note + '.long_form'
                                  | translate
                              }}
                              {{
                                'drugNameSearch.notes.SDS.description_XY'
                                  | translate
                                    : { rsdLimit: rsdLimit, msdLimit: msdLimit }
                              }}
                            </span>
                          </ng-template>
                          <ng-template #daySupply>
                            <span>
                              {{
                                'drugNameSearch.notes.' + note + '.long_form'
                                  | translate
                              }}
                              {{
                                'drugNameSearch.notes.SD.description_XY'
                                  | translate
                                    : {
                                        rsdSupply:
                                          otherInfo.retailSpecialtyDaySupply,
                                        msdSupply:
                                          otherInfo.mailSpecialtyDaySupply
                                      }
                              }}
                            </span>
                          </ng-template>
                          <ng-template #nyMessage>
                            <span>
                              {{
                                'drugNameSearch.notes.' + note + '.long_form'
                                  | translate
                              }}
                              ({{
                                'drugNameSearch.notes.' + note + '.short_form'
                                  | translate
                              }})
                              <br />
                              <br />
                              <span
                                [innerHTML]="
                                  'drugNameSearch.notes.' +
                                    note +
                                    '.descriptionNY' | translate
                                "
                              >
                              </span>
                            </span>
                          </ng-template>
                        </span>
                      </td>
                      <td class="ft-child" *ngIf="data.length === 0">
                        &#8203;
                      </td>
                    </tr>
                  </ng-container>
                </table>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
    <ng-container *ngIf="screen.isSmallerOrEqual('sm')">
      <table class="table drug-doublerow-table">
        <tbody>
          <ng-container
            *ngFor="let drug of selectedDrugList; let dIndex = index"
          >
            <table
              class="trow"
              [ngClass]="{
                oddRow: dIndex % 2 === 1,
                evenRow: dIndex % 2 !== 1
              }"
            >
              <tr>
                <th class="fc td-data">&nbsp;</th>
                <th class="sc bold cg-border header">
                  {{ 'drugNameSearch.drugs_grid_header.drug_name' | translate }}
                </th>
                <td class="td-data pl-2">
                  {{ drug.drugName }}
                  <div
                    class="info"
                    *ngIf="
                      (drug?.strength?.length ||
                        drug?.dosageFormDesc?.length ||
                        drug?.dosageForm?.length) >= 2
                    "
                  >
                    {{ 'drugNameSearch.multiple_variation_info' | translate }}
                  </div>
                </td>
              </tr>
              <tr>
                <th class="td-data">&nbsp;</th>
                <th class="bold cg-border header">
                  {{ 'drugNameSearch.drugs_grid_header.strength' | translate }}
                </th>
                <td class="td-data p-0">
                  <ng-container>
                    <table class="row-width">
                      <tr *ngFor="let strength of drug.strength">
                        <td class="ft-child" *ngIf="strength">
                          {{ strength }}
                        </td>
                        <td class="ft-child" *ngIf="!strength">&#8203;</td>
                      </tr>
                    </table>
                  </ng-container>
                </td>
              </tr>
              <tr>
                <th class="td-data">&nbsp;</th>
                <th class="bold cg-border header">
                  {{
                    'drugNameSearch.drugs_grid_header.dosage_form' | translate
                  }}
                </th>
                <td class="td-data p-0">
                  <ng-container>
                    <table class="row-width">
                      <tr *ngFor="let dosageForm of drug.dosageForm">
                        <td class="ft-child" *ngIf="dosageForm">
                          {{ dosageForm }}
                        </td>
                        <td class="ft-child" *ngIf="!dosageForm">&#8203;</td>
                      </tr>
                    </table>
                  </ng-container>
                </td>
              </tr>
              <tr>
                <th class="td-data">&nbsp;</th>
                <th class="bold cg-border header">
                  {{ 'drugNameSearch.drugs_grid_header.class' | translate }}
                </th>
                <td
                  class="td-data pl-2 word-brk clickable pdl-link"
                  (click)="
                    loadTherapeuticCode(drug.therapeuticClassCode, false)
                  "
                >
                  {{ drug.therapeuticClass }}
                </td>
              </tr>
              <tr>
                <th class="td-data">&nbsp;</th>
                <th class="bold cg-border header">
                  {{ 'drugNameSearch.drugs_grid_header.tier' | translate }}
                </th>
                <td class="td-data p-0">
                  <table class="row-width">
                    <ng-container *ngFor="let tier of drug.tier">
                      <tr>
                        <td class="ft-child" *ngIf="tier">
                          {{ tier }}
                        </td>
                      </tr>
                      <tr>
                        <td class="ft-child" *ngIf="!tier">&#8203;</td>
                      </tr>
                    </ng-container>
                  </table>
                </td>
              </tr>
              <tr>
                <th class="td-data">&nbsp;</th>
                <th class="bold cg-border header">
                  {{ 'drugNameSearch.drugs_grid_header.notes' | translate }}
                </th>
                <td class="td-data p-0">
                  <table class="row-width">
                    <ng-container *ngFor="let data of drug.notes">
                      <tr>
                        <td class="ft-child" *ngIf="data.length > 0">
                          <span *ngFor="let note of data; index as i">
                            <cigna-popover
                              popoverId="popover-notes"
                              role="button"
                              [underlineStyle]="'tooltip'"
                              [content]="popoverContent_notes"
                              [placement]="'right'"
                              [openOnHover]="true"
                            >
                              {{ note }}</cigna-popover
                            >
                            <label
                              *ngIf="data.length > 1 && i != data.length - 1"
                              >,</label
                            >
                            <ng-template #popoverContent_notes>
                              <span
                                *ngIf="
                                  !['SD', 'SDS'].includes(note) &&
                                    !(isNYMessage && note === 'DS');
                                  else nyMessage
                                "
                              >
                                {{
                                  'drugNameSearch.notes.' + note + '.long_form'
                                    | translate
                                }}
                                ({{
                                  'drugNameSearch.notes.' + note + '.short_form'
                                    | translate
                                }})
                                <br />
                                <br />
                                {{
                                  'drugNameSearch.notes.' +
                                    note +
                                    '.description' | translate
                                }}
                              </span>
                              <span *ngIf="note === 'SDS'">
                                <span
                                  *ngIf="msdLimit === rsdLimit; else dayLimit"
                                >
                                  {{
                                    'drugNameSearch.notes.' +
                                      note +
                                      '.long_form' | translate
                                  }}
                                  ({{
                                    'drugNameSearch.notes.' +
                                      note +
                                      '.short_form' | translate
                                  }})
                                  <br />
                                  <br />
                                  {{
                                    'drugNameSearch.notes.SDS.description_XX'
                                      | translate : { msdLimit: msdLimit }
                                  }}
                                </span>
                              </span>
                              <span *ngIf="note === 'SD'">
                                <span
                                  *ngIf="
                                    otherInfo.mailSpecialtyDaySupply ===
                                      otherInfo.retailSpecialtyDaySupply;
                                    else daySupply
                                  "
                                >
                                  {{
                                    'drugNameSearch.notes.' +
                                      note +
                                      '.long_form' | translate
                                  }}
                                  ({{
                                    'drugNameSearch.notes.' +
                                      note +
                                      '.short_form' | translate
                                  }})
                                  <br />
                                  <br />
                                  {{
                                    'drugNameSearch.notes.SD.description_XX'
                                      | translate
                                        : {
                                            msdSupply:
                                              otherInfo.mailSpecialtyDaySupply
                                          }
                                  }}
                                </span>
                              </span>
                            </ng-template>
                            <ng-template #dayLimit>
                              <span>
                                {{
                                  'drugNameSearch.notes.' + note + '.long_form'
                                    | translate
                                }}
                                {{
                                  'drugNameSearch.notes.SDS.description_XY'
                                    | translate
                                      : {
                                          rsdLimit: rsdLimit,
                                          msdLimit: msdLimit
                                        }
                                }}
                              </span>
                            </ng-template>
                            <ng-template #daySupply>
                              <span>
                                {{
                                  'drugNameSearch.notes.' + note + '.long_form'
                                    | translate
                                }}
                                {{
                                  'drugNameSearch.notes.SD.description_XY'
                                    | translate
                                      : {
                                          rsdSupply:
                                            otherInfo.retailSpecialtyDaySupply,
                                          msdSupply:
                                            otherInfo.mailSpecialtyDaySupply
                                        }
                                }}
                              </span>
                            </ng-template>
                            <ng-template #nyMessage>
                              <span>
                                {{
                                  'drugNameSearch.notes.' + note + '.long_form'
                                    | translate
                                }}
                                ({{
                                  'drugNameSearch.notes.' + note + '.short_form'
                                    | translate
                                }})
                                <br />
                                <br />
                                {{
                                  'drugNameSearch.notes.' +
                                    note +
                                    '.descriptionNY' | translate
                                }}
                              </span>
                            </ng-template>
                          </span>
                        </td>
                        <td class="ft-child" *ngIf="data.length === 0">
                          &#8203;
                        </td>
                      </tr>
                    </ng-container>
                  </table>
                </td>
              </tr>
            </table>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
  <ng-container
    *ngIf="
      otherInfo?.totalCount > loadedDataLength + 50 &&
      otherInfo?.totalCount > 50
    "
  >
    <div class="row" *ngIf="isClassCodeClicked; else isNotClicked">
      <button
        cignaButton="primary"
        class="view-more"
        (click)="
          loadTherapeuticCode(selectedDrugList[0]?.therapeuticClassCode, true)
        "
      >
        Load More
      </button>
    </div>
    <ng-template #isNotClicked>
      <div class="row">
        <button cignaButton="primary" class="view-more" (click)="loadMore()">
          Load More
        </button>
      </div>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="!showTableData">
    <div class="rx-cnt-error">
      {{
        'drugNameSearch.error_messages.hcp.service_error.message' | translate
      }}
    </div>
  </ng-container>
</ng-container>
<cigna-notes-definition
  *ngIf="selectedDrugList?.length > 0"
  [notesCollection]="notesCollection"
  [indicator]="indicator"
  [selectedItemDropDown]="selectedItemDropDown"
  [rsdLimitValue]="rsdLimit"
  [msdLimitValue]="msdLimit"
  [otherInfo]="otherInfo"
  [consumerId]="consumerId"
></cigna-notes-definition>
